<template>
  <form class="LOGIN-FORM" @submit.prevent="loginAs">
    <div class="h1 m-b-3" selenium="login-form-title">
      Spoof User
    </div>

    <template>
      <div class="input-container">
        <input
            v-vk-input
            :value="user"
            class="input"
            name="username"
            type="text"
            disabled>
        <label class="input-label">LDAP</label>
      </div>
      <div class="link d-flex jc-end m-b-2" @click="LDAPLogout()">Forget Me</div>

    </template>

    <div v-if="isSpoofed" class="link m-r-2" @click="stopLoginAs()">
      Stop Spoofing ({{ currentUsername }})
    </div>
    <div v-else>
      <div
          :class="{ 'error': validation.hasError('spoofedUsername') }"
          :error="validation.firstError('spoofedUsername')"
          class="input-container m-b-2"
          selenium="login-form-spoofed-username-input-container">
        <input
            v-vk-input
            v-model.trim="spoofedUsername"
            :disabled="loading"
            class="input"
            type="text">
        <label class="input-label">Spoofed Username</label>
      </div>

      <special-message ref="error" type="error" class="m-b-2" selenium="login-form-error">
        {{ errorMessage }}
      </special-message>

      <button
          :disabled="loading"
          type="submit"
          class="btn w-100"
          selenium="login-form-button">
        SPOOF USER
      </button>
    </div>
  </form>
</template>

<script>
import SimpleVueValidator, { Validator } from 'simple-vue-validator';
import { mapState, mapGetters, mapActions } from 'vuex';
import SpecialMessage from '@/components/SpecialMessage';
import PasswordField from '@/components/PasswordField';

export default {
  name: 'app-login-as-form',
  components: {
    SpecialMessage,
    PasswordField,
  },
  mixins: [SimpleVueValidator.mixin],
  data () {
    return {
      errorMessage: '',
      spoofedUsername: '',
      loading: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['user', 'accessToken']),
    ...mapState('loginspoof', [
      'isLDAPLoggedIn',
      'isSpoofed',
      'ldapUsername',
      'currentUsername',

    ]),
    hasLDAPLoggedIn () {
      return !!this.user && !!this.accessToken;
    },
  },
  validators: {
    spoofedUsername (value) {
      return Validator.value(value).required();
    },
  },
  methods: {
    ...mapActions('user', ['status']),
    async loginAs () {
      this.$refs.error.hide();
      const valid = await this.$validate();
      if (!valid) { return; }

      try {
        this.loading = true;
        await this.loginWithPingFed();
        await this.$store.dispatch('skeletonKey/loginAs', this.spoofedUsername);
        await this.$store.dispatch('user/status');

        this.loading = false;
        this.validation.reset();
        await this.$store.dispatch('loginspoof/update');
        this.redirectTo();
      } catch (err) {
        console.error(err); // eslint-disable-line no-console
        this.$refs.error.trigger(10000);

        if (err.response && err.response.status === 404) {
          this.errorMessage = `${this.spoofedUsername} does not exist. Please check the username`;
        } else if (err.response && err.response.status === 403) {
          this.errorMessage = 'You don\'t have permissions for this action.';
        } else {
          this.errorMessage = 'We can\'t find the LDAP or password that you entered. Please try again.';
        }
        this.loading = false;
        this.$store.dispatch('loginspoof/update');
      }
    },

    async stopLoginAs () {
      await this.$store.dispatch('skeletonKey/stopLoginAs');
      await this.$store.dispatch('loginspoof/update');
      await this.$store.commit('user/clear');
    },

    async LDAPLogout () {
      this.$store.dispatch('skeletonKey/stopLoginAs');
      await this.$store.dispatch('loginspoof/logout');
      await this.$store.commit('user/clear');
    },

    redirectTo () {
      const isPro = this.$store.getters['user/isPro'];
      const dashboard = isPro ? 'dashboard' : 'consumer::dashboard';
      const { redirect } = this.$route.query;
      this.$router.push(redirect ? { path: redirect } : { name: dashboard });
    },
    async loginWithPingFed () {
      const grantType = 'ping_fed_login';
      try {
        await this.$store.dispatch('skeletonKey/loginWithPingfed', {
          accessToken: this.accessToken, grantType,
        });
      } catch (err) {
        console.error('loginPingFed error', err);
        throw err;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .LOGIN-FORM {
    @include responsive(width, 100%, 350px);
  }
</style>
